import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const EditQuickBuyModalLazy = React.lazy(() =>
  import('./EditQuickBuyModal').then((m) => ({ default: m.EditQuickBuyModal })),
);
type EditQuickBuyModalProps = React.ComponentProps<
  typeof import('./EditQuickBuyModal').EditQuickBuyModal
>;

NiceModal.register(
  MODALS.EDIT_QUICK_BUY,
  NiceModal.create((props: EditQuickBuyModalProps) => (
    <Suspense fallback={null}>
      <EditQuickBuyModalLazy {...props} />
    </Suspense>
  )),
);
